
// Angular
import { Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { map } from 'rxjs/operators';
import { of as observableOf ,  Observable } from 'rxjs';

// Afidium
import { Yii } from "libraries/interfaces/Yii";
import { ConfigFieldBuilderService } from "../config-field-builder.service";
import { SERVICE_ARRAY_FIELD } from "../config";
import { IFieldSpecs } from "libraries/module/formbuilder/fields/interfaces/field-specs";
import { IMultiselectOptions } from "libraries/module/formbuilder/fields/multiselect/multiselect.model";
import { HelperService } from "app_sasha/shared/services/helper.service";
import { ICodeName } from "libraries/service/resources/model/shared/ICodeName";
import { BookingService } from "libraries/service/booking/booking.service";
import { SsrsService } from "libraries/service/ssrs/Ssrs.service";
import {
    ApiMembershipCard,
    ApiSeatAssignment,
    ApiServiceXStatus
} from "libraries/service/resources/booking/interfaces/ApiSearchParameters";
import { IChipsAutocompleteItem } from "libraries/module/formbuilder/fields/chips-date/chips-date.component";
import { ESashaPermissions } from "../../../../../libraries/enums/e-sasha-permissions";

interface IFieldConfig {
    [name: string]: IFieldSpecs;
}

@Component({
    selector: 'service-fieldset',
    template: `
        <div class="sep-top">
            <collapsible [title]="serviceSearchTitle" [open]="open">
                <div class="col-to-row-s-tb sep-top">
                    <div class="flex-1">
                        <chips
                            [fieldConfig]="formFields.serviceCode"
                            [autocompleteList]="filteredServices | async"
                            [toUpper]="chipsToUpper"
                            (onChangeInput)="filterAutocompleteList($event)"></chips>
                    </div>
                    <div class="flex-1 sep-left">
                        <multiselect
                            [fieldConfig]="formFields.serviceXStatus"
                            [options]="serviceXStatusOptions"></multiselect>
                    </div>
                </div>
                <div class="sep-top" *permissionIf="sashaPermissions.SASHA_BOOKING_SEARCH_SERVICE_NO_SEAT_ASSIGNMENT_SHOW">
                    <multiselect
                            [fieldConfig]="formFields.hasSeatAssignment"
                            [options]="seatAssignmentOptions" [maxSelection]="1"></multiselect>
                </div>
            </collapsible>
        </div>
    `,
    providers: [SsrsService]
})
export class ServiceFieldsetComponent implements OnInit {
    @Input()
    public form: FormGroup;

    @Input()
    public open: boolean = true;

    @Input()
    public chipsToUpper: boolean;

    public readonly serviceSearchTitle: string = Yii.t('wui-sasha-js', 'Services');

    public formFields: IFieldConfig;
    public filteredServices: Observable<IChipsAutocompleteItem[]> = observableOf([]);
    public serviceXStatusOptions: IMultiselectOptions[] = [];
    public sashaPermissions: typeof ESashaPermissions = ESashaPermissions;
    public seatAssignmentOptions: IMultiselectOptions[];

    constructor(
        private readonly configFieldBuilderService: ConfigFieldBuilderService,
        private readonly helperService: HelperService,
        private readonly bookingService: BookingService,
        private readonly ssrsService: SsrsService,
    ) { }

    public ngOnInit(): void {
        this.filterAutocompleteList('');
        this.formFields = {
            ...this.configFieldBuilderService.buildFieldConfigArray(this.form, SERVICE_ARRAY_FIELD)
        };

        this.serviceXStatusOptions = this.helperService.getMultiselectOptions(
            this.bookingService.serviceXStatusLabels,
            Object.values(ApiServiceXStatus),
            true
        );

        this.seatAssignmentOptions = this.helperService.getMultiselectOptions(
            this.bookingService.seatAssignmentLabels,
            Object.values(ApiSeatAssignment),
            false
        );
    }

    public filterAutocompleteList(value: string): void {
        this.filteredServices = this.ssrsService.search(value).pipe(
            map((list: ICodeName[]) => list.map((item: ICodeName) => ({ label: item.name, value: item.code }))));
    }
}
